
import React from 'react';
import { motion } from 'framer-motion';
import { Sliders, Zap, Laptop, Music4 } from 'lucide-react';

const Equipment: React.FC = () => {
  return (
    <section id="equipment" className="py-24 relative overflow-hidden bg-dark-lighter/20">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-6 space-y-8"
          >
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-3">
                <div className="h-px w-8 bg-gold" />
                <span className="text-gold text-[10px] font-bold tracking-[0.4em] uppercase">Performance Technique</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-serif font-bold leading-tight">
                Un Matériel <br />
                <span className="text-gold-gradient italic">Professionnel.</span>
              </h2>
            </div>

            <p className="text-lg text-white/60 font-light leading-relaxed">
              Pour garantir un rendu d'exception, je n'utilise que le meilleur standard de l'industrie. Mon équipement est sélectionné pour sa fiabilité et sa qualité sonore irréprochable.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-6 glass rounded-3xl border-white/5 space-y-4 group hover:bg-gold/[0.02] transition-colors">
                <Sliders className="text-gold w-8 h-8" />
                <h3 className="font-bold text-sm uppercase tracking-widest">Régie Pioneer FLX 10</h3>
                <p className="text-xs text-white/40 leading-relaxed">Le standard actuel pour une précision de mix chirurgicale et des transitions fluides.</p>
              </div>

              <div className="p-6 glass rounded-3xl border-white/5 space-y-4 group hover:bg-gold/[0.02] transition-colors">
                <Music4 className="text-gold w-8 h-8" />
                <h3 className="font-bold text-sm uppercase tracking-widest">Système Sono Pro</h3>
                <p className="text-xs text-white/40 leading-relaxed">Une diffusion sonore puissante et cristalline adaptée à la configuration de votre lieu.</p>
              </div>

              <div className="p-6 glass rounded-3xl border-white/5 space-y-4 group hover:bg-gold/[0.02] transition-colors">
                <Zap className="text-gold w-8 h-8" />
                <h3 className="font-bold text-sm uppercase tracking-widest">Habillage Lumineux</h3>
                <p className="text-xs text-white/40 leading-relaxed">Une installation élégante qui sublime votre décoration et dynamise la piste de danse.</p>
              </div>

              <div className="p-6 glass rounded-3xl border-white/5 space-y-4 group hover:bg-gold/[0.02] transition-colors">
                <Laptop className="text-gold w-8 h-8" />
                <h3 className="font-bold text-sm uppercase tracking-widest">Configuration Stable</h3>
                <p className="text-xs text-white/40 leading-relaxed">Logiciels et matériel de pointe pour une performance sans interruption toute la nuit.</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-6"
          >
            <div className="relative rounded-[3rem] overflow-hidden aspect-video lg:aspect-square glass border-white/5 p-2 bg-black group">
              <img 
                src="images/djsaff-materiel.jpg" 
                alt="Pioneer DJ Setup"
                className="w-full h-full object-cover rounded-[2.5rem] grayscale opacity-50 group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-1000 scale-105 group-hover:scale-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent pointer-events-none" />
              
              <div className="absolute bottom-10 left-10 right-10">
                <div className="glass backdrop-blur-xl p-6 rounded-2xl border-white/10">
                  <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold mb-1">Qualité Garantie</p>
                  <p className="text-sm text-white/80 font-light">"Chaque détail technique est pensé pour servir l'harmonie de votre évènement."</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Equipment;
